import createClient from "openapi-fetch";
import type { components, paths } from "./schema";

export type Schemas = components["schemas"];
export type Job = Schemas["Job"];
export type JobStatus = Schemas["JobStatus"];
export type JobQueue = Schemas["JobQueue"];
export type Me = Schemas["Me"];
export type Channel = Schemas["ChannelSummary"];
export type ChannelDetail = Schemas["ChannelDetail"];
export type ChannelStatus = Schemas["ChannelStatus"];
export type StyleContent = Schemas["StyleContent"];
export type StyleProfileView = Schemas["StyleProfileView"];
export type Schedule = Schemas["ScheduleView"];
export type ScheduleRules = Schemas["ScheduleRules"];
export type WeeklyRules = Schemas["WeeklyRules"];
export type Slot = Schemas["Slot"];
export type SlotView = Schemas["SlotView"];
export type BuildSettings = Schemas["BuildSettings"];
export type PublicationKind = Schemas["PublicationKind"];
export type PublicationStatus = Schemas["PublicationStatus"];
export type PublicationPlatform = Schemas["PublicationPlatform"];
export type Publication = Schemas["Publication"];
export type PublicationView = Schemas["PublicationView"];
export type BulkDeleteResult = Schemas["BulkDeleteResult"];
export type YoutubeMoveView = Schemas["YoutubeMoveView"];
export type ChannelContents = Schemas["ChannelContents"];
export type Asset = Schemas["AssetView"];
export type RecordingInfo = Schemas["RecordingInfo"];
export type RecordingStatus = Schemas["RecordingStatus"];
export type Notification = Schemas["Notification"];
export type Dashboard = Schemas["Dashboard"];
export type Generation = Schemas["Generation"];
export type GenerationView = Schemas["GenerationView"];
export type GenerationKind = Schemas["GenerationKind"];
export type GenStatus = Schemas["GenStatus"];
export type ImageView = Schemas["ImageView"];
export type ImageRollup = Schemas["ImageRollup"];
export type LineageView = Schemas["LineageView"];
export type LineageNode = Schemas["LineageNodeView"];
export type LineageEdge = Schemas["LineageEdgeView"];
export type LineageKind = Schemas["LineageKind"];
export type Song = Schemas["SongView"];
export type ItemKind = Schemas["ItemKind"];
export type SongStatus = Schemas["SongStatus"];
export type SongLoop = Schemas["SongLoopView"];
export type LoopSearch = Schemas["LoopSearch"];
export type SongLoopStatus = Schemas["SongLoopStatus"];
export type TrackLoopView = Schemas["TrackLoopView"];
export type Voice = Schemas["VoiceView"];
export type VoiceStatus = Schemas["VoiceStatus"];
export type LyricsSource = Schemas["LyricsSource"];
export type ProviderBudgets = Schemas["ProviderBudgets"];
export type Budget = Schemas["Budget"];
export type SpendingSummary = Schemas["SpendingSummary"];
export type WorkerView = Schemas["WorkerView"];
export type WorkerTranscription = Schemas["WorkerTranscription"];
export type TranscriptionSettings = Schemas["TranscriptionSettings"];
export type TranscriptionEngine = Schemas["TranscriptionEngine"];
export type TranscriptionModel = Schemas["TranscriptionModel"];
export type TranscriptionNow = Schemas["TranscriptionNow"];
export type BuilderArchive = Schemas["Archive"];
export type CreatedWorker = Schemas["CreatedWorker"];
export type Project = Schemas["Project"];
export type ProjectStatus = Schemas["ProjectStatus"];
export type ProjectAssetRole = Schemas["ProjectAssetRole"];
export type ProjectAssetView = Schemas["ProjectAssetView"];
export type ProjectSongView = Schemas["ProjectSongView"];
export type Template = Schemas["Template"];
export type CompositionOptions = Schemas["CompositionOptions"];
export type VizKindOption = Schemas["VizKindOption"];
export type LookElement = Schemas["LookElement"];
export type ElementContent = Schemas["ElementContent"];
export type ElementColor = Schemas["ElementColor"];
export type VisualizerKind = Schemas["VisualizerKind"];
export type CoverOutline = Schemas["CoverOutline"];
export type ProjectPalette = Schemas["ProjectPalette"];
export type PreviewView = Schemas["PreviewView"];
export type RevealModeOption = Schemas["RevealModeOption"];
export type Anchor = Schemas["Anchor"];
export type OverlayStyle = Schemas["OverlayStyle"];
export type OverlaySource = Schemas["OverlaySource"];
export type OverlayPulse = Schemas["OverlayPulse"];
export type SequenceOptions = Schemas["SequenceOptions"];
export type SequenceSwitchOption = Schemas["SequenceSwitchOption"];
export type SequenceTransitionOption = Schemas["SequenceTransitionOption"];
export type SequenceScope = Schemas["SequenceScope"];
export type RevealSpan = Schemas["RevealSpan"];
export type RevealDriverOption = Schemas["RevealDriverOption"];
export type ReactSignal = Schemas["ReactSignal"];
export type Reactivity = Schemas["Reactivity"];
export type ReactivityOptions = Schemas["ReactivityOptions"];
export type Release = Schemas["Release"];
export type ReleaseView = Schemas["ReleaseView"];
export type ReleaseKind = Schemas["ReleaseKind"];
export type ReleaseStatus = Schemas["ReleaseStatus"];
export type AiCredits = Schemas["AiCredits"];
export type AiOrigin = Schemas["AiOrigin"];
export type ReleaseSettings = Schemas["ReleaseSettings"];
export type Clip = Schemas["Clip"];
export type TimelineView = Schemas["TimelineView"];
export type TimelineItem = Schemas["TimelineItem"];
export type SpeechMapView = Schemas["SpeechMapView"];
export type SpeechMapsView = Schemas["SpeechMapsView"];
export type SpeechMapState = Schemas["SpeechMapState"];
export type SpeechWord = Schemas["SpeechWord"];
export type MixdownView = Schemas["MixdownView"];
export type MixdownSource = Schemas["MixdownSource"];
export type MixdownStatus = Schemas["MixdownStatus"];
export type LoudnessPlan = Schemas["LoudnessPlan"];
export type LoudnessInput = Schemas["LoudnessInput"];
export type LoudnessItem = Schemas["LoudnessItem"];
export type LoudnessResult = Schemas["LoudnessResult"];
export type LoudnessStatus = Schemas["LoudnessStatus"];
export type PlanTotals = Schemas["PlanTotals"];
export type TrimPlanInput = Schemas["PlanInput"];
export type TrimPlanItemInput = Schemas["PlanItemInput"];
export type TrimSettings = Schemas["TrimSettings"];
export type SyncPlanView = Schemas["SyncPlanView"];
export type SyncResult = Schemas["SyncResult"];
export type SyncStatus = Schemas["SyncStatus"];
export type MulticamInput = Schemas["MulticamInput"];
export type MulticamPlan = Schemas["MulticamPlan"];
export type MulticamSettings = Schemas["MulticamSettings"];
export type MulticamShot = Schemas["Shot"];
export type SyncConfidence = Schemas["SyncConfidence"];
export type TrimPlan = Schemas["PlanOutput"];
export type TrimItemPlan = Schemas["ItemPlan"];
export type TimelineItemView = Schemas["TimelineItemView"];
export type TimelineSettings = Schemas["TimelineSettings"];
export type TimelineTrackView = Schemas["TimelineTrackView"];
export type TimelineTransition = Schemas["TimelineTransition"];
export type TimelinePlayback = Schemas["TimelinePlayback"];
export type TimelinePan = Schemas["TimelinePan"];
export type TimelineFit = Schemas["TimelineFit"];
export type TimelineLane = Schemas["TimelineLane"];
export type ClipStatus = Schemas["ClipStatus"];
export type ClipSuggestionView = Schemas["ClipSuggestionView"];
export type SeriesPlan = Schemas["SeriesPlan"];
export type ScheduleResult = Schemas["ScheduleResult"];
export type SessionView = Schemas["SessionView"];
export type LoginAttemptView = Schemas["LoginAttemptView"];
export type NotificationEventStatus = Schemas["NotificationEventStatus"];
export type TimelineOverlay = Schemas["TimelineOverlay"];
export type Timing = Schemas["Timing"];
export type TimePoint = Schemas["TimePoint"];
export type LinkTarget = Schemas["LinkTarget"];
export type TimeOffset = Schemas["Offset"];
export type TimeEdge = Schemas["Edge"];
export type SectionKey = Schemas["SectionKey"];
export type TrackSection = Schemas["Section"];
export type OverlayContentInput = Schemas["OverlayContentInput"];
export type OverlayText = Schemas["OverlayText"];
export type OverlayQr = Schemas["OverlayQr"];
export type OverlayCaption = Schemas["OverlayCaption"];
export type OverlayMotion = Schemas["OverlayMotion"];
export type OverlayAnimation = Schemas["OverlayAnimation"];
export type QrSource = Schemas["QrSource"];
export type QrFill = Schemas["QrFill"];
export type QrIconChoice = Schemas["QrIconChoice"];
export type QrIconColor = Schemas["QrIconColor"];
export type FontFamily = Schemas["FontFamily"];
export type FontView = Schemas["FontView"];
export type TextAlign = Schemas["TextAlign"];
export type LinkPlatform = Schemas["LinkPlatform"];
export type ChannelLink = Schemas["ChannelLink"];
export type SongLinksView = Schemas["SongLinksView"];
export type EffectiveLink = Schemas["EffectiveLink"];
export type OverlayImage = Schemas["OverlayImage"];
export type OverlayShape = Schemas["OverlayShape"];
export type OverlayVideo = Schemas["OverlayVideo"];
export type OverlayVisualizer = Schemas["OverlayVisualizer"];
export type OverlayBackground = Schemas["OverlayBackground"];
export type OverlayVignette = Schemas["OverlayVignette"];
export type OverlayGroup = Schemas["OverlayGroup"];
export type GroupChildInput = Schemas["GroupChildInput"];
export type ChildContentInput = Schemas["ChildContentInput"];
export type OverlayTextBox = Schemas["OverlayTextBox"];
export type OverlayTextShadow = Schemas["OverlayTextShadow"];
export type OverlayTextOutline = Schemas["OverlayTextOutline"];
export type ImageSource = Schemas["ImageSource"];
export type ImageFit = Schemas["ImageFit"];
export type ShapeKind = Schemas["ShapeKind"];
export type OverlayTextFrame = Schemas["OverlayTextFrame"];
export type OverlayBorder = Schemas["OverlayBorder"];
export type FormatKey = Schemas["FormatKey"];
export type FormatMode = Schemas["FormatMode"];
export type FormatLayout = Schemas["FormatLayout"];
export type Placement = Schemas["Placement"];
export type ClipFraming = Schemas["ClipFraming"];
export type ProjectFormatView = Schemas["ProjectFormatView"];
export type CutRule = Schemas["CutRule"];
export type CutPlan = Schemas["CutPlan"];
export type ProposedCut = Schemas["ProposedCut"];
export type NewCutInput = Schemas["NewCutInput"];
export type UpdateClipInput = Schemas["UpdateClipInput"];
export type OutputPlan = Schemas["OutputPlan"];
export type OutputSpec = Schemas["OutputSpec"];
export type SpacingPlan = Schemas["SpacingPlan"];
export type SchedulePlanView = Schemas["SchedulePlanView"];
export type ScheduleItem = Schemas["ScheduleItem"];
export type ScheduleOutputsResult = Schemas["ScheduleOutputsResult"];
export type GenerateOutputsResult = Schemas["GenerateOutputsResult"];
export type RenderCutsResult = Schemas["RenderCutsResult"];
export type TemplateFormatDef = Schemas["TemplateFormatDef"];
export type LyricsTimingView = Schemas["LyricsTimingView"];
export type AlignedLine = Schemas["AlignedLine"];
export type Chorus = Schemas["Chorus"];
export type ChorusMethod = Schemas["ChorusMethod"];
export type BlendMode = Schemas["BlendMode"];
export type Ease = Schemas["Ease"];
export type ReactionInput = Schemas["ReactionInput"];
export type ReactionKind = Schemas["ReactionKind"];
export type ReactionSignal = Schemas["ReactionSignal"];
export type TransformKey = Schemas["TransformKey"];
export type RevealUnit = Schemas["RevealUnit"];
export type RevealCursor = Schemas["RevealCursor"];
export type TextRevealInput = Schemas["TextRevealInput"];
export type TypingSound = Schemas["TypingSound"];
export type TypingSoundSource = Schemas["TypingSoundSource"];
export type TypingEvery = Schemas["TypingEvery"];
export type BlipName = Schemas["BlipName"];
export type BlipView = Schemas["BlipView"];
export type SongWindow = Schemas["SongWindow"];
export type TemplateView = Schemas["TemplateView"];
export type TemplateContent = Schemas["TemplateContent"];
export type FormatComposition = Schemas["FormatComposition"];
export type TemplateScope = Schemas["TemplateScope"];
export type TimelineTrackRow = Schemas["TimelineTrack"];
export type TrackKind = Schemas["TrackKind"];
export type TemplateFormat = Schemas["TemplateFormat"];
export type TemplateRef = Schemas["TemplateRef"];
export type ChannelLookView = Schemas["ChannelLookView"];
export type StyleInput = Schemas["StyleInput"];
export type GlowInput = Schemas["GlowInput"];
export type ShadowInput = Schemas["ShadowInput"];
export type StrokeInput = Schemas["StrokeInput"];
export type VizMirror = Schemas["VizMirror"];
export type LogoView = Schemas["LogoView"];
export type LogoVersionView = Schemas["LogoVersionView"];
export type LogosView = Schemas["LogosView"];
export type WaitlistSignup = Schemas["Signup"];
export type WaitlistStats = Schemas["Stats"];
export type WaitlistStatus = Schemas["WaitlistStatus"];
export type WaitlistUseCase = Schemas["UseCase"];
export type WaitlistPriceRange = Schemas["PriceRange"];
export type WaitlistInviteLink = Schemas["InviteLink"];

/** An error returned by the API envelope `{"error": {"code", "message"}}`. */
export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message: string,
    /** Validation problems (`422`), one sentence each. */
    readonly details: string[] = [],
  ) {
    super(message);
    this.name = "ApiError";
  }
}

/** The problems to show for a failed request: the details when present, else the message.
 * `[]` for `null`/`undefined` (a mutation's `.error` before it has ever run, or after a
 * successful one) — every call site passes this straight through unconditionally
 * (`problemsOf(mutation.error)`, not `mutation.isError ? problemsOf(...) : []`), so this
 * used to render a permanent, bogus "can't be reached" box on forms that had never even
 * been submitted. */
export function problemsOf(err: unknown): string[] {
  if (err == null) {
    return [];
  }
  if (err instanceof ApiError) {
    return err.details.length > 0 ? err.details : [err.message];
  }
  // A plain `Error` is one this app threw on purpose, with a message meant to be read;
  // anything else (a fetch `TypeError`, a body that is not JSON) is the network.
  if (err instanceof Error && err.constructor === Error && err.message) {
    return [err.message];
  }
  return ["The studio can't be reached. Check your connection and try again."];
}

/** Typed client for `/api/*`; the session cookie travels automatically (same origin). */
export const api = createClient<paths>({ baseUrl: "", credentials: "same-origin" });

type Result<T> = { data?: T; error?: unknown; response: Response };

/** Returns the response data, or throws an {@link ApiError}. */
export async function unwrap<T>(request: Promise<Result<T>>): Promise<T> {
  const { data, error, response } = await request;
  if (response.ok) {
    return data as T;
  }
  const body = error as Partial<Schemas["ErrorBody"]> | undefined;
  throw new ApiError(
    response.status,
    body?.error?.code ?? "http_error",
    // A proxy's HTML error page has no envelope, and HTTP/2 has no status text.
    body?.error?.message || response.statusText || `HTTP ${response.status}`,
    detailMessages(body?.error?.details),
  );
}

function detailMessages(details: unknown): string[] {
  if (!Array.isArray(details)) {
    return [];
  }
  return details.flatMap((d: unknown) => {
    if (typeof d === "string") {
      return [d];
    }
    const message = (d as { message?: unknown } | null)?.message;
    return typeof message === "string" ? [message] : [];
  });
}
